import React from "react";
import { AiFillCloseCircle, AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";
import { MdArrowDropDown } from "react-icons/md";

type NavbarProps = {
  active: string;

  isOpen: boolean;

  toggleSidebar: () => void;
  data: any;
};

const Navbar: React.FC<NavbarProps> = ({
  active,

  isOpen,

  data,
  toggleSidebar,
}) => {
  return (
    <div className="w-full py-5 fixed pl-12 z-20 lg:pr-64 right-0 lg:left-[15%] h-24 top-0 bg-[#fbfafa]">
      <div className="w-[90%] flex justify-between items-center">
        <div className="flex gap-5 items-center">
          <div className="flex  lg:hidden">
            {/* Hamburger button */}
            <div className=" cursor-pointer" onClick={toggleSidebar}>
              {isOpen ? (
                <AiFillCloseCircle size={30} />
              ) : (
                <AiOutlineMenu size={30} />
              )}
            </div>
          </div>
          {active && (
            //   <p className="text-black font-Poppins text-[20px] font-bold  ">
            //     Verify your profile
            //   </p>
            // ) : (
            <p className="text-black font-Poppins text-[20px] font-bold  ">
              {active && active === 'Ads' ? active + ' Manager' : active }
            </p>
          )}
        </div>
        <div className="flex gap-3 items-center cursor-pointer">
          <Link
            to="/dashboard"
            className="flex justify-center items-center gap-2"
          >
            <p className="text-lightGreen text-center font-Inter font-medium leading-6 text-[16px] p-2 bg-darkGreen rounded-full">
              {data.user.username.slice(0, 2).toUpperCase()}
            </p>
            {/* <p className="text-midGreen first-letter:capitalize font-Poppins text-[16px] font-normal leading-5 ">
              {data.user.username}
            </p> */}
          </Link>
          <div className="w-11 h-11 rounded-full bg-[#5F4AE51A] items-center flex justify-center">
            <MdArrowDropDown color="black" size={28} />
          </div>
          

          {/* <div className=" hidden lg:block ">
            <Web3Button icon="hide" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
